import { createStore, combineReducers, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'
import { reducer as formReducer } from 'redux-form'

// Add all reducers here
const reducers = {
  form: formReducer
}

// Add all middleware here
const middleware = [ ]

export default initialState => {
  const store = createStore(
    combineReducers({ ...reducers }),
    initialState,
    composeWithDevTools(
      applyMiddleware(
          thunkMiddleware,
          ...middleware
      )
    )
  )
  return store
}



// WEBPACK FOOTER //
// ./src/store/createStore.js